// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.overlay[data-v-a560e192]{z-index:-999;left:0;background:rgba(11,10,12,.35);opacity:0;width:100%;transition:opacity .3s ease}aside.drawer[data-v-a560e192],div.overlay[data-v-a560e192]{position:fixed;top:0;height:100%}aside.drawer[data-v-a560e192]{z-index:9999;will-change:transform;transition:transform .3s ease;background:#fff;width:300px;min-width:300px;overflow-y:auto;overflow-x:hidden;word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
